var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 41.1923V25.9694M41 52.4757V52.6095M71.4458 41.1923C71.4458 58.0071 57.8148 71.6381 41 71.6381C24.1852 71.6381 10.5542 58.0071 10.5542 41.1923C10.5542 24.3776 24.1852 10.7465 41 10.7465C57.8148 10.7465 71.4458 24.3776 71.4458 41.1923Z",
    stroke: "#ED1C24",
    strokeWidth: 6.76573,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailure);
export default __webpack_public_path__ + "static/media/failure.d0a354447e28d1fc6f63303d39da8868.svg";
export { ForwardRef as ReactComponent };